import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { VendorPermission } from 'angular/app/core/models/entities/permission';
import { fromStore } from 'angular/app/core/store';

@Component({
  selector: 'app-settings-page',
  template: `
    <h1 class="dashboard mt-3">Réglages</h1>
    
    <div class="mt-8 space-y-6" data-cy="advanced-settings">
      <ng-template [appHasPermission]="VendorPermission.Update">
        <div>
          <app-list-item
            data-cy="vendor-settings-page"
            [defaultClickRouterLink]="['/reglages/hote']"
            >
            <div class="flex items-center" title>
              <i class="fal fa-lg fa-house w-10"></i>
              <span class="font-bold">Profil de l'organisation</span>
            </div>
            <app-icon-action
              actions
              icon="chevron-right"
              [routerLink]="['/reglages/hote']"
            ></app-icon-action>
          </app-list-item>
        </div>
    
        <div>
          <app-list-item
            [defaultClickRouterLink]="['/reglages/mode-test']"
            [attr.data-cy]="'rates-page'"
            >
            <div class="flex items-center" title>
              <i class="fa-light fa-lg fa-flask-vial w-10"></i>
              <span class="font-bold">Mode test</span>
            </div>
            <app-icon-action
              actions
              icon="chevron-right"
              [routerLink]="['/reglages/mode-test']"
            ></app-icon-action>
          </app-list-item>
        </div>
    
        <div>
          <app-list-item
            [defaultClickRouterLink]="['/reglages/groupes-de-tarifs']"
            [attr.data-cy]="'rates-page'"
            >
            <div class="flex items-center" title>
              <i class="fa-light fa-lg fa-sliders w-10"></i>
              <span class="font-bold">Groupes de tarifs</span>
            </div>
            <app-icon-action
              actions
              icon="chevron-right"
              [routerLink]="['/reglages/groupes-de-tarifs']"
            ></app-icon-action>
          </app-list-item>
        </div>
    
        <div>
          <app-list-item
            [defaultClickRouterLink]="['/reglages/modes-de-paiement']"
            [attr.data-cy]="'rates-page'"
            >
            <div class="flex items-center" title>
              <i class="fa-light fa-lg fa-money-check-pen w-10"></i>
              <span class="font-bold">Modes de paiement internes</span>
            </div>
            <app-icon-action
              actions
              icon="chevron-right"
              [routerLink]="['/reglages/modes-de-paiement']"
            ></app-icon-action>
          </app-list-item>
        </div>
    
        <div>
          <app-list-item
            [defaultClickRouterLink]="['/reglages/conditions-generales']"
            [attr.data-cy]="'general-terms-page'"
            >
            <div title class="flex items-center">
              <i class="fa-light fa-lg fa-file-contract w-10"></i>
              <span class="whitespace-nowrap font-bold"
                >Conditions générales</span
                >
              </div>
    
              <app-icon-action
                actions
                icon="chevron-right"
                [routerLink]="['/reglages/conditions-generales']"
              ></app-icon-action>
            </app-list-item>
          </div>
    
          <div>
            <app-list-item
              [defaultClickRouterLink]="['/reglages/conditions-annulation']"
              [attr.data-cy]="'cancel-conditions-page'"
              >
              <div class="flex items-center" title>
                <i class="fa-light fa-lg fa-align-slash w-10"></i>
                <span class="whitespace-nowrap font-bold"
                  >Conditions d’annulation</span
                  >
                </div>
                <app-icon-action
                  actions
                  icon="chevron-right"
                  [routerLink]="['/reglages/conditions-annulation']"
                ></app-icon-action>
              </app-list-item>
            </div>
    
            <div>
              <app-list-item
                [defaultClickRouterLink]="['/reglages/ouverture-calendrier']"
                [attr.data-cy]="'calendar-constraints-page'"
                >
                <div class="flex items-center" title>
                  <i class="fa-light fa-lg fa-calendar-day w-10"></i>
                  <span class="whitespace-nowrap font-bold"
                    >Ouverture du calendrier</span
                    >
                  </div>
                  <app-icon-action
                    actions
                    icon="chevron-right"
                    [routerLink]="['/reglages/ouverture-calendrier']"
                  ></app-icon-action>
                </app-list-item>
              </div>
    
              <div>
                <app-list-item
                  [defaultClickRouterLink]="['/reglages/modeles-communication']"
                  [attr.data-cy]="'communication-templates-page'"
                  >
                  <div class="flex items-center" title>
                    <i class="fa-light fa-lg fa-books w-10"></i>
                    <span class="whitespace-nowrap font-bold"
                      >Modèles de communication</span
                      >
                    </div>
                    <app-icon-action
                      actions
                      icon="chevron-right"
                      [routerLink]="['/reglages/modeles-communication']"
                    ></app-icon-action>
                  </app-list-item>
                </div>
    
                <div>
                  <app-list-item
                    data-cy="authentication-settings-page"
                    [defaultClickRouterLink]="['/reglages/securite']"
                    >
                    <div class="flex items-center" title>
                      <i class="fal fa-lg fa-shield-check w-10"></i>
                      <span class="font-bold">Sécurité</span>
                    </div>
                    <app-icon-action
                      actions
                      icon="chevron-right"
                      [routerLink]="['/reglages/securite']"
                    ></app-icon-action>
                  </app-list-item>
                </div>
              </ng-template>
            </div>
    
            <hr />
    
            @if (user$ | async; as user) {
              <div>
                <app-list-item
                  [defaultClickRouterLink]="['/louer-salle/', user.vendor.slug]"
                  >
                  <div class="flex items-center" title>
                    <i class="fa-light fa-lg fa-external-link mr-6"></i>
                    <span class="whitespace-nowrap font-bold">Votre page publique</span>
                  </div>
                  <app-icon-action
                    actions
                    icon="chevron-right"
                    [routerLink]="['/louer-salle/', user.vendor.slug]"
                  ></app-icon-action>
                </app-list-item>
              </div>
            }
    `,
  styles: [],
  standalone: false,
})
export class SettingsPageComponent implements OnInit {
  user$ = this.store.select(fromStore.selectAuthUser);
  VendorPermission = VendorPermission;
  constructor(private store: Store) {}

  ngOnInit(): void {}
}
